// @flow

import {
  FORGOT_PASSWORD_SET_SUCCESS,
  FORGOT_PASSWORD_SET_ERROR,
  FORGOT_PASSWORD_SET_REQUEST,
  FORGOT_PASSWORD_SET_CLEAR
} from './constants';

import type { Action, FormValues } from '../types';

export const requestForgotPasswordSet = (formValues: FormValues): Action => ({
  type: FORGOT_PASSWORD_SET_REQUEST,
  formValues
});

export const errorForgotPasswordSet = (): Action => ({
  type: FORGOT_PASSWORD_SET_ERROR
});

export const successForgotPasswordSet = (): Action => ({
  type: FORGOT_PASSWORD_SET_SUCCESS
});

export const clearForgotPasswordSet = (): Action => ({
  type: FORGOT_PASSWORD_SET_CLEAR
});
